import { render, staticRenderFns } from "./SuperUsers.vue?vue&type=template&id=2b7582b4&"
import script from "./SuperUsers.vue?vue&type=script&lang=js&"
export * from "./SuperUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports